import {Component, Input, OnInit} from '@angular/core';
import {AssignUserToAlert, Role, UserProfile} from "@flowmaps-com/flowmaps-typescriptmodels";
import {View} from "../../../common/view";
import {RefdataUtils} from "../../refdata/refdata-utils";
import {map, Observable} from "rxjs";
import {AppContext} from "../../../app-context";

@Component({
    selector: 'app-alert-user-details',
    templateUrl: './alert-user-details.component.html',
    styleUrls: ['./alert-user-details.component.css']
})
export class AlertUserDetailsComponent extends View implements OnInit {
    @Input() data;
    user: UserProfile
    command: AssignUserToAlert
    refDataUtils = RefdataUtils;

    ngOnInit(): void {
        this.command = {alertId: this.data.alert.alertId};
        this.user = this.data.user;
    }

    searchUsers = (term: string): Observable<UserProfile[]> =>
        this.subscribeTo("searchUsers", term).pipe(map(users => {
            if (AppContext.isAdmin()) {
                return users;
            }
            const intermediaryId = AppContext?.userProfile?.intermediaryId;
            const allowedRoles = [Role.manager, Role.owner, Role.intermediary];
            return users.filter(user => user.receivedAuthorisations
                .filter(a => a.entityIds.length === 0 && !a.revoked)
                .some(a => allowedRoles.includes(a.role) &&
                    a.nominator === intermediaryId));
        }));

    updateUser = () => {
        this.sendCommand('com.flowmaps.api.monitoring.alerting.AssignUserToAlert', this.command);
    };

    onUserSelected(event: any) {
        this.command.assigneeId = event == null ? null : event.userId
    }
}
